import Divider from '@mui/material/Divider';
import Popover from '@mui/material/Popover';
import { ReactComponent as SupportAgentIcon } from '../../../../../assets/icons/Navegation/atn.svg';
import { ReactComponent as SubmenuIcon } from '../../../../../assets/icons/Navegation/submenu-flecha.svg';
import MenuCheckByDirectNumberWidget from '../../widgets/MenuCheckByDirectNumberWidget';
import { headerTitleStyle, icons, triangle } from '../Styles/StylesIcons';
import GenericCollapse from './GenericCollapse';
import GenericNavListItem from './GenericNavListItem';
import GenericListItemButton from './MenuItemWithSubmenu';

const TriangleIcon = (props) => <SubmenuIcon style={triangle} {...props} />;

const SupportTicketsMenu = ({
  userPermissions,
  openMenuSupport,
  handleClickSupport,
  activeStyle,
  props,
  drawerOpen,
  handlePopoverOpen,
  handlePopoverClose,
  openPopover,
  header,
  anchorEl,
}) => {
  const submenuContent = (
    <>
      <GenericNavListItem
        userPermissions={userPermissions}
        permission='SUPPORT_TICKETS_ACTIONS'
        to='/my-tickets'
        title='Mis incidencias'
        IconComponent={TriangleIcon}
        activeStyle={activeStyle}
      />
      <GenericNavListItem
        userPermissions={userPermissions}
        permission='SUPPORT_TICKETS_SUPERVISOR'
        to='/tickets'
        title='Incidencias'
        IconComponent={TriangleIcon}
        activeStyle={activeStyle}
      />
      <GenericNavListItem
        userPermissions={userPermissions}
        permission='SUPPORT_TICKETS_ACTIONS'
        to='/sales/orders'
        title='Órdenes de compra Dalefon'
        IconComponent={TriangleIcon}
        activeStyle={activeStyle}
      />
      <GenericNavListItem
        userPermissions={userPermissions}
        permission='SUPPORT_TICKETS_ACTIONS'
        to='/sales/orders-ipb'
        title='Órdenes de compra IPB'
        IconComponent={TriangleIcon}
        activeStyle={activeStyle}
      />
      <GenericNavListItem
        userPermissions={userPermissions}
        permission='SUPPORT_TICKETS_ACTIONS'
        to='/list/ipb'
        title='Compra Paquetes de SIMs IPB'
        IconComponent={TriangleIcon}
        activeStyle={activeStyle}
      />
      <GenericNavListItem
        userPermissions={userPermissions}
        permission='CANVASSING_OPERATIONS_SUPERVISOR, SUPPORT_TICKETS_SUPERVISOR'
        to='/list/failed_transactions_ipb'
        title='Transacciones fallidas IPB'
        IconComponent={TriangleIcon}
        activeStyle={activeStyle}
      />
      <GenericNavListItem
        userPermissions={userPermissions}
        permission='SUPPORT_TICKETS_ACTIONS'
        to='/sales/gift-orders'
        title='Órdenes de regalo'
        IconComponent={TriangleIcon}
        activeStyle={activeStyle}
      />
      <GenericNavListItem
        userPermissions={userPermissions}
        permission='SUPPORT_TICKETS_SUPERVISOR'
        to='/sales/gift-sim-ipb'
        title='Regalo SIM IPB'
        IconComponent={TriangleIcon}
        activeStyle={activeStyle}
      />

      <GenericNavListItem
        userPermissions={userPermissions}
        permission='SUPPORT_TICKETS_SUPERVISOR'
        to='/sales/free-trial-ipb'
        title='Prueba Gratis IPB'
        IconComponent={TriangleIcon}
        activeStyle={activeStyle}
      />

      <GenericNavListItem
        userPermissions={userPermissions}
        permission='SUPPORT_TICKETS_ACTIONS'
        to='/portabilidades'
        title='Portabilidades'
        IconComponent={TriangleIcon}
        activeStyle={activeStyle}
      />
      <GenericNavListItem
        userPermissions={userPermissions}
        permission='CANVASSING_OPERATIONS_SUPERVISOR, SUPPORT_TICKETS_SUPERVISOR'
        to='/offerids'
        title='OfferIDs'
        IconComponent={TriangleIcon}
        activeStyle={activeStyle}
      />

      <GenericNavListItem
        userPermissions={userPermissions}
        permission='SUPPORT_TICKETS_SUPERVISOR'
        to='/pre-register/gift-sim-dalefon'
        title='Pre-registro de SIMS de regalo Dalefon'
        IconComponent={TriangleIcon}
        activeStyle={activeStyle}
      />
    </>
  );

  return (
    <>
      {(userPermissions?.includes('SUPPORT_TICKETS_ACTIONS') ||
        userPermissions?.includes('SUPPORT_TICKETS_SUPERVISOR') ||
        userPermissions?.includes('CANVASSING_OPERATIONS_SUPERVISOR')) && (
        <>
          <Divider style={{ margin: '0 0 4px 0' }} />
          {drawerOpen && (
            <>
              {header?.support.kind === 'header' && (
                <div style={headerTitleStyle}>{header.support.title}</div>
              )}
            </>
          )}
          <GenericListItemButton
            onClick={drawerOpen ? handleClickSupport : handlePopoverOpen}
            className={'layout-menu-submenu'}
            title='Soporte Dalefon'
            IconComponent={(props) => <SupportAgentIcon style={icons} {...props} />}
            openMenu={openMenuSupport}
          />
          {drawerOpen && (
            <GenericCollapse
              className={'layout-menu-submenu-options'}
              openMenu={openMenuSupport}
              userPermissions={userPermissions}
            >
              {userPermissions?.includes('SUPPORT_TICKETS_ACTIONS') && (
                <MenuCheckByDirectNumberWidget
                  parentProps={props}
                  userPermissions={userPermissions}
                />
              )}
              {submenuContent}
            </GenericCollapse>
          )}
          {!drawerOpen && (
            <Popover
              open={openPopover}
              anchorEl={anchorEl}
              onClose={handlePopoverClose}
              onBlur={handlePopoverClose}
              anchorOrigin={{
                vertical: 'top',
                horizontal: 'right',
              }}
              transformOrigin={{
                vertical: 'top',
                horizontal: 'left',
              }}
              PaperProps={{
                style: { minWidth: 220 },
                onMouseLeave: handlePopoverClose,
              }}
            >
              <div style={{ padding: 8 }}>{submenuContent}</div>
            </Popover>
          )}
        </>
      )}
    </>
  );
};

export default SupportTicketsMenu;
